import { isNetworkError } from "../../../../../api/runQueryFn";

export const PIN_ERROR_MESSAGES = {
  pinIsTooShort: "Введите 4 цифры",
  incorrectPin: "Неправильный код",
  networkError: "Не удалось выполнить запрос. Попробуйте ещё раз",
};

export function getPinRequestErrorMessage(error: Error | null): string {
  if (error && isNetworkError(error) && error.status === 456 && error.internalCode === 7070) {
    return PIN_ERROR_MESSAGES.incorrectPin;
  }

  return PIN_ERROR_MESSAGES.networkError;
}

export function getValidationErrorMessage(pin: string) {
  switch (true) {
    case pin.length < 4: return PIN_ERROR_MESSAGES.pinIsTooShort;
    default: return null;
  }
}
